import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	issuesCountLabel: {
		id: 'polaris-ideas.view-content.idea-board.swimlanes.body.draggable-group-sticky-header.issues-count-label',
		defaultMessage: '{issuesCount, plural, =0 {} =1 {# idea} other {# ideas}}',
		description: '',
	},
});
